import { JSX, useCallback, useState } from "react";
import { ModalLink } from "@app/shared/Modals";
import { CompetitiveInsightsManageAddModalBody } from "@app/overviews/network-benchmarking-dashboard/manage/CompetitiveInsightsManageAddModalBody";
import { CompetitiveInsightsManageModalMode } from "@app/overviews/network-benchmarking-dashboard/manage/shared/CompetitiveInsightsManageModalMode";
import { CompetitiveInsightsSupersetProjectConfigurations } from "@app/overviews/network-benchmarking-dashboard/manage/shared/CompetitiveInsightsSupersetProjectConfigurations";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QesColors } from "@app/shared/qes-standards/colors";

interface CompetitiveInsightsManageAddModalProps {
  configuration?: CompetitiveInsightsSupersetProjectConfigurations;
  mode: CompetitiveInsightsManageModalMode;
}

export const CompetitiveInsightsManageAddModal = (props: CompetitiveInsightsManageAddModalProps): JSX.Element => {
  const isEdit = props.mode === "edit";
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  const [submitAction, setSubmitAction] = useState<() => void>(() => () => {});

  const onSubmitActionChange = useCallback((action: () => void) => setSubmitAction(() => action), []);

  return (
    <ModalLink
      content={{
        body: (
          <CompetitiveInsightsManageAddModalBody
            configuration={props.configuration}
            mode={props.mode}
            onSubmitActionChange={onSubmitActionChange}
            onValidityChange={setIsFormValid}
          />
        ),
        cancelButtonText: "Cancel",
        confirmButtonAction: () => submitAction(),
        confirmButtonDisable: !isFormValid,
        confirmButtonText: isEdit ? "Save Changes" : "Save Configuration",
        title: isEdit ? "Edit Configuration" : "Add New Configuration"
      }}
      classNames={isEdit ? "qes-button-secondary p-1 me-2" : "qes-button-primary"}
      testId={isEdit ? `competitive-insights__manage--table-edit-${props.configuration?.projectId}` : "competitive-insights__manage--add-new-configuration"}
      hideBodyScroll={true}
      modalWidth={25}
    >
      {isEdit ? (
        <QesIcon iconName={QesIcons.PencilV1} color={QesColors.Blue500} description="Edit" />
      ) : (
        "Add New Configuration"
      )}
    </ModalLink>
  );
}

